// 高德地图 API 配置
export const amapConfig = {
  // API 密钥
  key: '1aa0c76cc8b8c8ca765424a3cbe2789d',
  // 安全密钥
  securityJsCode: '22bcde8ca7646ade9a7bd24def1e245f'
}

// 设置全局安全密钥
export function setAmapSecurityConfig() {
  window._AMapSecurityConfig = {
    securityJsCode: amapConfig.securityJsCode
  }
}

// 生成高德地图 SDK 加载 URL
export function getAmapScriptUrl(plugins = []) {
  const { key } = amapConfig
  const pluginStr = plugins.length > 0 ? `&plugin=${plugins.join(',')}` : ''
  // 注意：URL中不要包含 securityJsCode
  return `https://webapi.amap.com/maps?v=2.0&key=${key}${pluginStr}`
}

/** 仅注入一条核心 maps 脚本，避免主地图与 LeftJoin 各插一条导致竞态与 Script error */
let amapCorePromise = null

function pollAmapReady(resolve, reject) {
  const iv = setInterval(() => {
    if (window.AMap) {
      clearInterval(iv)
      resolve()
    }
  }, 50)
  setTimeout(() => {
    clearInterval(iv)
    if (!window.AMap) {
      amapCorePromise = null
      reject(new Error('高德地图核心库加载超时'))
    }
  }, 25000)
}

function waitAmapCore() {
  if (window.AMap) {
    return Promise.resolve()
  }
  if (!amapCorePromise) {
    amapCorePromise = new Promise((resolve, reject) => {
      setAmapSecurityConfig()
      const existing = document.querySelector('script[src*="webapi.amap.com/maps"]')
      if (existing) {
        pollAmapReady(resolve, reject)
        return
      }
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = getAmapScriptUrl([])
      script.onerror = () => {
        amapCorePromise = null
        reject(new Error('高德脚本加载失败'))
      }
      script.onload = () => pollAmapReady(resolve, reject)
      document.head.appendChild(script)
    })
  }
  return amapCorePromise
}

/**
 * 加载高德 2.0：全局只拉取一次核心 JS，其余通过 AMap.plugin 补齐，避免多入口重复 script。
 */
export function loadAmapSDK(plugins = []) {
  const wanted = [...new Set((plugins || []).filter(Boolean))]
  return waitAmapCore().then(
    () =>
      new Promise((resolve, reject) => {
        if (!window.AMap) {
          reject(new Error('AMap 未就绪'))
          return
        }
        if (!wanted.length) {
          resolve(window.AMap)
          return
        }
        try {
          window.AMap.plugin(wanted, () => resolve(window.AMap))
        } catch (e) {
          reject(e)
        }
      })
  )
}
